import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
export function PricingSection() {
  return <section id="offer" className="scroll-mt-20 bg-brand-alt px-4 py-20 md:py-28" data-id="element-127" data-mp="19jxdvgf8bdcx">
      <Reveal className="mx-auto max-w-3xl text-center" data-id="element-128" data-mp="1ehytfrdg4ujn">
        <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-green" data-id="element-129" data-mp="1egdyw1r4tbls">LIMITED-TIME PRICE</p>
        <h2 className="mb-12 text-3xl font-black text-brand-deep md:text-4xl" data-id="element-130" data-mp="1nakb145ccv6w">🏆 Special Launch Offer</h2>
        <div className="relative mx-auto max-w-xl overflow-hidden rounded-[2rem] border-2 border-brand-green bg-brand-alt shadow-xl" data-id="element-131" data-mp="1s9dfk72nhbux">
          <div className="bg-brand-deep px-6 py-4 text-[11px] font-extrabold tracking-[0.14em] text-white" data-id="element-132" data-mp="1x9rqbwvmyzwn">
            BIOLOGY READY — COMPLETE PACK
          </div>
          <div className="p-8 md:p-12" data-id="element-133" data-mp="2uywa2aeih6t">
            <div className="space-y-4 text-left" data-id="element-134" data-mp="2w0goxdb4g17">
              <PriceLine label="10-Volume Biology Ready Pack" price="$197" data-id="element-135" data-mp="7ts6nlue5s2r" />
              <PriceLine label="5 Exclusive Bonuses" price="$195" data-id="element-136" data-mp="7vwdocnl7779" />
              <div className="flex items-center justify-between border-t border-brand-dark pt-5 text-sm font-bold" data-id="element-137" data-mp="1mhg9skngd5a3">
                <span data-id="element-138" data-mp="1hon51wrzhwy0">TOTAL VALUE:</span>
                <span className="text-brand-green line-through" data-id="element-139" data-mp="1cqlmre2du1nl">$392</span>
              </div>
            </div>
            <div className="my-8 border-y border-brand-dark py-7" data-id="element-140" data-mp="17sac5149jn4b">
              <p className="text-xs font-extrabold tracking-[0.16em] text-brand-green" data-id="element-141" data-mp="17pxn64038chr">TODAY ONLY</p>
              <p className="mt-2 font-serif text-6xl font-black tracking-tight text-brand-deep md:text-7xl" data-id="element-142" data-mp="25d6be6rh3zng">
                $27 <span className="text-2xl" data-id="element-143" data-mp="1vh312dmgwupf">USD</span>
              </p>
            </div>
            <CTAButton href="https://biology-ready.impultienda.ar/checkout" className="w-full py-5 text-lg" data-id="element-144" data-mp="1rfrl6ztebnuf">
              GET THE BIOLOGY READY PACK
            </CTAButton>
            <p className="mt-6 text-xs font-semibold text-brand-gray" data-id="element-145" data-mp="k3iswz8nif3o">
              One-time payment · Instant download · Lifetime access
            </p>
          </div>
        </div>
      </Reveal>
    </section>;
}
function PriceLine({
  label,
  price
}: {
  label: string;
  price: string;
}) {
  return <div className="flex items-center justify-between border-b border-brand-dark pb-4 text-sm" data-id="element-146" data-mp="mg30r2ot6y2q">
      <span className="font-medium" data-id="element-147" data-mp="7jc4316is0gt">{label}</span>
      <span className="font-bold text-brand-deep" data-id="element-148" data-mp="ci5e2jmll9c8">{price}</span>
    </div>;
}